import { render, staticRenderFns } from "./fees.vue?vue&type=template&id=4c4de706&scoped=true&"
import script from "./fees.vue?vue&type=script&lang=js&"
export * from "./fees.vue?vue&type=script&lang=js&"
import style0 from "./fees.vue?vue&type=style&index=0&id=4c4de706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4de706",
  null
  
)

export default component.exports